import React from "react";
import { useNavigate } from "react-router-dom";
import fast from "../assets/holypicture.jpg";

const FastAd = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center px-4 sm:px-8 md:px-16 lg:px-24 py-10">
      <div className="relative flex flex-col md:flex-row items-center w-full bg-white rounded-xl shadow-lg overflow-hidden min-h-[500px] md:min-h-[600px]">
        {/* Image Section */}
        <img
          src={fast}
          alt="Daily Devotional"
          className="w-full md:w-1/2 lg:w-1/3 h-80 md:h-96 lg:h-[450px] object-cover"
        />

        {/* Content Section */}
        <div className="flex flex-col justify-center p-8 md:w-1/2 lg:w-2/3 text-center md:text-left">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">Daily Devotional</h2>
          <p className="mt-4 text-gray-700 text-base sm:text-lg leading-relaxed">
            Start your day with inspiration and guidance. Read our daily devotional and be spiritually uplifted.
          </p>
          <button
            onClick={() => navigate("/fast")}
            className="mt-6 bg-orange-500 text-white h-[70px] w-[260px] text-lg rounded-lg shadow-md hover:bg-orange-700 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            aria-label="Read Today's Devotional"
          >
            Read Today's Devotional
          </button>
        </div>
      </div>
    </div>
  );
};

export default FastAd;
